<template>
    <div class="page">
        <div class="page-bd">
            <div class="edit-box">
                <div class="mg-right10">
                    <Input v-model="search.org_from2_cname">
                        <span slot="prepend">{{$t('org_from2_cname')}}{{$t('x_yd')}}</span>
                    </Input>
                </div>
                <div class="mg-right10">
                    <Input v-model="search.org_fr_cname">
                        <span slot="prepend">{{$t('org_cname')}}{{$t('x_yd')}}</span>
                    </Input>
                </div>
                <div class="mg-right10"><Button type="primary" @click="list">{{$t('list')}}</Button></div>
            </div>
<!--            <div class="edit-box">-->
<!--                <div class="mg-right10">-->
<!--                    <Input v-model="search.min_money_amt_from2" class="w150">-->
<!--                        <span slot="prepend">{{$t('from2_yue_xd')}} {{$t('xy_dy')}}</span>-->
<!--                    </Input>-->
<!--                </div>-->
<!--                <div class="mg-right10">-->
<!--                    <Input v-model="search.min_money_amt_fr" class="w150">-->
<!--                        <span slot="prepend">{{$t('from3_yue_xd')}} {{$t('xy_dy')}}</span>-->
<!--                    </Input>-->
<!--                </div>-->
<!--                <div class="mg-right10">-->
<!--                    <Input v-model="search.min_yfee_qty">-->
<!--                        <span slot="prepend">{{$t('yfee_xd')}} {{$t('xy_dy')}}</span>-->
<!--                    </Input>-->
<!--                </div>-->
<!--            </div>-->
            <div class="tree-box">
                <div v-for="(item, index) in listData" :key="index">
                    <span class="f-blue">
                        <Icon class="left-icon" type="ios-arrow-down" />{{item.org_cname}}
                        <span>[ID:{{item.org_id}}] ({{$t('bal')}}{{item.money_amt}})</span>
                    </span>
                    <div class="pd-top10 pd-bottom10">
<!--                        <span class="tag warning" @click="openSet(item)">{{$t("set_add")}}</span>-->
                        <span class="tag primary" @click="openSave(item)">{{$t("info")}}</span>
                    </div>
                    <div class="sub-tree c1 f14">
                        <div class="sub-tree c3" v-for="(item2, kk) in item.downs" :key="kk">
                            <span>
                                <Icon type="ios-ionic" size="20" v-if="item2.org_status == '1'" class="f-green" />
                                <Icon type="ios-ionic" size="20" v-else class="f-red" />
                                {{item2.org_cname}}
                                <span class="user-code-font">
                                    [ID:{{item2.org_id}}] ({{$t('bal')}}{{item2.money_amt}}) ({{$t('org_grade')}}{{$t('x_mh')}}<span class="f-red">{{item2.org_grade_cdesc}}</span>{{$t('x_fh')}}
                                    <span v-if="!$base.isEmpty(item2.date_to)">
                                        {{$t('bal_day_qty')}}{{$t('x_mh')}}
                                        <span class="f-red">{{item2.bal_day_qty}}{{$t('day')}}</span>{{$t('x_fh')}}
                                    </span>{{$t('exp_date')}}{{$t('x_mh')}}{{item2.date_to || $t('undefined')}})
                                </span>
                            </span>
                            <div class="pd-top10 pd-bottom10">
                                <span class="tag warning" @click="openSet(item2)">{{$t("set_add")}}</span>
                                <span class="tag primary" @click="openSave(item2)">{{$t("info")}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <myNodata v-show="totalData.total <= 0" :last_time="search.search_time" style="width:100%;"></myNodata>
            </div>
            <div class="table-pager pd-top10 pd-bottom10" v-show="totalData.total > 0">
                <myPager :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </div>
        <!-- <download-excel :data="excelData" :fields="exportHeader" :name="export_title" v-show="false">
            <a type="success" ref="btn_excel"></a>
        </download-excel> -->
        <Drawer class="drawer-sub-view" :title="sub_title" v-model="show_subview" width="850" :mask-closable="false" placement="left" :closable="false">
            <router-view></router-view>
        </Drawer>
    </div>
</template>

<script>
    import myPager from '../../../components/myPager'
    import myNodata from '../../../components/myNodata'
    import myDropdown from '../../../components/myDropdown'
    export default {
        name:'org-downs1',
        components:{
            myPager,
            myNodata,
            myDropdown
        },
        data:function(){
            const listHeader = {
                goods_cat: this.$t('package_cat'),
                goods_cname: this.$t('package_name'),
                org_grade:this.$t('org_grade2'),
                goods_price:this.$t('price'),
                msg_qty:this.$t('msg_qty'),
                money_amt:this.$t('mj'),
                yfee_qty:this.$t('yfee_qty'),
                goods_status:this.$t('status'),
                add_time:this.$t('add_time'),
            };
            return{
                title: this.$t('org_down'),
                export_title: '',
                sub_title:"",//子界面名称
                show_subview:false,
                relist:false,
                search:{
                    search_url: "org-down-s1/list",
                    search_time: new Date(),//最新查询时间
                    org_from_cname: "", // 总店名称
                    org_from2_cname: "", // 区域名称
                    org_fr_cname: "",
                    date_fr: '',
                    date_to: '',
                    page: 1,
                    limit: 5,
                    pageSize: 0,
                    min_money_amt_from: '',
                    min_money_amt_from2: '',
                    min_money_amt_fr: '',
                    min_msg_qty: '',
                    min_yfee_qty: ''
                },
                listHeader,//表结构
                listData: [],
                excelData: [],
                exportHeader : this.$base.changeJsonKeyValue(listHeader),
                totalData: {
                    total: 0,//总行数
                },
                goods_cat: []
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.list();
        },
        methods:{
            onDateChange: function(data){
                this.search.date_fr = data[0];
                this.search.date_to = data[1];
            },
            onSearchTextChange: function(data){
                this.list();
            },
            onPagerChange: function () {
                this.list(true);
            },
            onLimitChange: function (limit) {
                this.search.limit = limit;
                this.list();
            },
            onLevelsChange:function () {
                this.list();
            },
            list: function (change_page) {
                if(!change_page) this.search.page = 1;
                this.search.search_time = new Date();
                this.$base.showLoading();
                this.$request.sendPost(this.search.search_url,this.search,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.listData = data.list;
                        this.search.pageSize = parseInt(data.last_page);
                        this.totalData.total = data.total.total;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            exportExcel: function(){
                this.$base.exportExcel(this);
            },
            openAdd:function (name, org_id, org_level) {
                this.sub_title = this.$t('add') +'('+ name +')' + this.$t('di_label') + this.title;
                this.$base.linkTo('downs1/add', {org_id, org_level});
            },
            openSave:function (item) {
                this.sub_title = this.$t('upd') +'('+ item.org_cname +')' + this.$t('di_label') + this.title;
                this.$base.linkTo('downs1/upd', {org_id: item.org_id, org_level: item.org_level});
            },
            openSet:function (item) {
                this.sub_title = this.$t('setup') +'('+ item.org_cname +')' + this.$t('di_label') + this.title;
                this.$base.linkTo('downs1/setup', {org_id: item.org_id, data: JSON.stringify(item)});
            },
            openHighSet:function (item) {
                this.sub_title = this.$t('highset') +'('+ item.org_cname +')' + this.$t('di_label') + this.title;
                this.$base.linkTo('downs1/higset', {org_id: item.org_id, data: JSON.stringify(item)});
            },
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(this.search.page);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>
    .tree-box{
        max-width: 1000px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/org/down/downs1.vue